import { ref } from 'vue'
import type { RouteLocationNormalizedGeneric } from 'vue-router'

const routeHistory = ref<RouteLocationNormalizedGeneric[]>([])

export function useRouterClient() {
  const addRoute = (route: RouteLocationNormalizedGeneric) => {
    if (import.meta.server) return

    routeHistory.value.push(route)
    if (routeHistory.value.length > 15) {
      routeHistory.value.shift()
    }
  }

  const getReferrer = (): RouteLocationNormalizedGeneric | undefined => {
    if (import.meta.server) return undefined
    return routeHistory.value.length > 1
      ? routeHistory.value[routeHistory.value.length - 2]
      : undefined
  }

  const getHistory = (): RouteLocationNormalizedGeneric[] => {
    if (import.meta.server) return []
    return [...routeHistory.value]
  }

  const routeChanged = (route: RouteLocationNormalizedGeneric) => {
    addRoute(route)
  }

  return {
    routeChanged,
    getReferrer,
    getHistory,
  }
}
